import React from "react";

const RangeSlider = ({
  label,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  unit = "",
}) => {
  return (
    <div className="range-setting">
      <div className="range-label">
        <span>{label}:</span>
        <div className="range-actions">
          <input
            type="number"
            value={value}
            onChange={(e) => {
              const newValue = Math.min(Math.max(Number(e.target.value), min), max);
              onChange(newValue);
            }}
            min={min}
            max={max}
            step={step}
            className="range-number-input"
          />
          <span className="range-unit">{unit}</span>
        </div>
      </div>

      <div className="range-slider-container">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          className="range-slider"
          style={{
            background: `linear-gradient(to right, 
              var(--range-filled-color) 0%, 
              var(--range-filled-color) ${((value - min) / (max - min)) * 100}%, 
              var(--range-empty-color) ${((value - min) / (max - min)) * 100}%, 
              var(--range-empty-color) 100%)`,
          }}
        />
        <div className="range-ticks">
          <span>
            {min}
            {unit}
          </span>
          <span>
            {max}
            {unit}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RangeSlider;
